export const getSalesperson = `
query GetTaskById($id: Int!) { 
  taskById(id: $id) { 
    success 
    message 
    data { 
      id 
      title 
      module 
      description 
      priority 
      status 
      requestedDate 
      startDate 
      endDate 
      deadlineDate 
      assignedTo { 
        id
        username 
      } 
    } 
  } 
}`;



//Get Task Title
export const getAllTask = `query { 
    allTasks {  
      success   
      message  
      data {   
        id 
        title 
        status  
        deadlineDate 
        assignedTo { 
          id 
          username 
        } 
      } 
    } 
} `;

//List
export const getTaskList = `
query allProgressUpdates($id:Int,$status:String) { 
  allProgressUpdates (userId:$id,workStatus:$status){ 
    success 
    error 
    message 
    data { 
      id 
      task { 
        id 
        title 
        assignedTo{ 
          id 
          firstName 
          lastName 
          username 
        } 
      } 
      status 
      workCompleted 
      totalHoursSpent 
      hoursWorked 
      createdAt 
      isReviewed 
      remainingTime 
    } 
  } 
}  `;

//View By Id
export const getTaskProgressById = `
query GetProgressUpdateById($id: Int!) { 
  progressUpdateById(id: $id) { 
    success 
    message 
    error 
    data { 
      id 
      task { 
        id 
        title 
        assignedTo { 
          id
					firstName
          lastName
          username 
        } 
      } 
      status 
      workCompleted 
      hoursWorked 
      totalHoursSpent
      remainingTime
      isReviewed 
      createdAt 
    	
    } 
  } 
} `;


//Task Progress Details by Task ID
export const getTaskProgressDetails = `
query GetProgressUpdatesByTask($taskId: Int!) { 
  progressUpdatesByTask(taskId: $taskId) { 
    success 
    message 
    error 
    data { 
      id 
      task { 
        id 
        title 
        requestedDate 
        startDate 
        endDate 
        deadlineDate 
        assignedTo{
          id
          firstName
          lastName
          username
        }
      } 
      remainingTime 
      status 
      workCompleted 
      hoursWorked 
      totalHoursSpent   
      isReviewed 
      createdAt 
    } 
  } 
} `;


//SalesPerson list
export const getSalespersonList = `
  query getUserDetailByMaster($id: String!) {
    getUserDetailByMaster(id: $id) {
      id
      username
      email
      role
      contactno
      lastUpdate
    }
  }`;

//Create Task
export const createTaskProgressMutation = `
mutation CreateTaskProgress($input: CreateTaskProgressInput!) { 
  createProgress(input: $input) { 
    success 
    error 
    message 
    data { 
      id 
      task { 
        id 
        title 
      } 
      assignedTo{ 
        id 
        firstName 
        lastName 
      } 
      status 
      workCompleted 
      hoursWorked 
      isReviewed 
      createdAt 
    } 
  } 
} `;

//Edit Task
export const updateTaskProgressMutation = `
mutation UpdateProgress($input: UpdateTaskProgressInput!) { 
  updateProgress(input: $input) { 
    success 
    error 
    message 
    data { 
      id 
     status 
      workCompleted 
      hoursWorked 
      isReviewed 
      createdAt 
    } 
  } 
} `;

//Delete task
export const deleteTaskProgressMutation = `
mutation DeleteProgress($id: Int!) { 

  deleteProgress(id: $id) { 

    success 

    error 

    message 

  } 

} 
`;